import { NavItemType } from "shared/Navigation/NavigationItem";
import ncNanoId from "utils/ncNanoId";


export const NAVIGATION_DEMO_2: NavItemType[] = [

  {
    id: ncNanoId(),
    href: "/",
    name: "Home",
  },
  {
    id: ncNanoId(),
    href: "/customers",
    name: "Customers",
  },
  {
    id: ncNanoId(),
    href: "/planes",
    name: "Plans",
  },
  // {
  //   id: ncNanoId(),
  //   href: "/external-services",
  //   name: "Servicios relacionados",
  // },
  {
    id: ncNanoId(),
    href: "/about",
    name: "About us",
  },
  {
    id: ncNanoId(),
    href: "/contact",
    name: "Contact",
  },
  // {
  //   id: ncNanoId(),
  //   href: "/politics-private",
  //   name: "politics private",
  // },

];
